import { render, staticRenderFns } from "./newspaperOfPc.vue?vue&type=template&id=7cb87dda&scoped=true&"
import script from "./newspaperOfPc.vue?vue&type=script&lang=js&"
export * from "./newspaperOfPc.vue?vue&type=script&lang=js&"
import style0 from "./newspaperOfPc.vue?vue&type=style&index=0&id=7cb87dda&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb87dda",
  null
  
)

export default component.exports